module.exports = __webpack_public_path__ + "img/home1_yinliu_logo2.a3f49de8.png";